import actions from "./actions";

const initState = {
    repushActivationActivationList: [],
    repushActivationLoading: false,
    repushActivationError: null,
    searchButtonLoading: false,

    buttonLoading: false,
    updateRepushActivationError: null,
    updateRepushActivationMessage: null,

    prepaidIQActivatioList: [],
    prepaidIQActivatioListLoading: false,
    prepaidIQActivatioListError: null,
    prepaidIQsearchButtonLoading: false,

    prepaidIqButtonLoading: false,
    updatePrePaidIQActivationError: null,
    updatePrePaidiQActivationMessage: null,

    portinActivatioList: [],
    portinActivatioListLoading: false,
    portinActivatioListError: null,
    portinsearchButtonLoading: false,

    portinButtonLoading: false,
    updatePortinActivationError: null,
    updatePortinActivationMessage: null,
};

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.GET_REPUSH_ACTIVATION:
            return {
                ...state,
                searchButtonLoading: true,
                repushActivationActivationList: [],
                repushActivationLoading: true,
                repushActivationError: null,
            };
        case actions.GET_REPUSH_ACTIVATION_SUCCESS:
            return {
                ...state,
                searchButtonLoading: false,
                repushActivationLoading: false,
                repushActivationActivationList: action.result,
                repushActivationError: null,
            };
        case actions.GET_REPUSH_ACTIVATION_FAILED:
            return {
                ...state,
                searchButtonLoading: false,
                repushActivationLoading: false,
                repushActivationError: action.error,
            };
        case actions.UPDATE_REPUSH_ACTIVATION:
            return {
                ...state,
                buttonLoading: true,
                updateRepushActivationError: null,
                updateRepushActivationMessage: null,
            };
        case actions.UPDATE_REPUSH_ACTIVATION_SUCCESS:
            return {
                ...state,
                buttonLoading: false,
                updateRepushActivationMessage: action.message,
                updateRepushActivationError: null,
            };
        case actions.UPDATE_REPUSH_ACTIVATION_FAILED:
            return {
                ...state,
                buttonLoading: false,
                updateRepushActivationMessage: false,
                updateRepushActivationError: action.error,
            };
        case actions.RESET_MESSAGE:
            return {
                ...state,
                updateRepushActivationError: null,
                updateRepushActivationMessage: null,
                updatePrePaidIQActivationError: null,
                updatePrePaidiQActivationMessage: null,
                updatePortinActivationError: null,
                updatePortinActivationMessage: null,
            };

        case actions.GET_PREPAIDIQ_ACTIVATION_FOR_REPUSH:
            return {
                ...state,
                prepaidIQsearchButtonLoading: true,
                prepaidIQActivatioList: [],
                prepaidIQActivatioListLoading: true,
                prepaidIQActivatioListError: null,
            };
        case actions.GET_PREPAIDIQ_ACTIVATION_FOR_REPUSH_SUCCESS:
            return {
                ...state,
                prepaidIQsearchButtonLoading: false,
                prepaidIQActivatioListLoading: false,
                prepaidIQActivatioList: action.result,
                prepaidIQActivatioListError: null,
            };
        case actions.GET_PREPAIDIQ_ACTIVATION_FOR_REPUSH_FAILED:
            return {
                ...state,
                prepaidIQsearchButtonLoading: false,
                prepaidIQActivatioListLoading: false,
                prepaidIQActivatioListError: action.error,
            };
        case actions.UPDATE_PREPAIDIQ_ACTIVATION_FOR_REPUSH:
            return {
                ...state,
                prepaidIqButtonLoading: true,
                updatePrePaidIQActivationError: null,
                updatePrePaidiQActivationMessage: null,
            };
        case actions.UPDATE_PREPAIDIQ_ACTIVATION_FOR_REPUSH_SUCCESS:
            return {
                ...state,
                prepaidIqButtonLoading: false,
                updatePrePaidiQActivationMessage: action.message,
                updatePrePaidIQActivationError: null,
            };
        case actions.UPDATE_PREPAIDIQ_ACTIVATION_FOR_REPUSH_FAILED:
            return {
                ...state,
                prepaidIqButtonLoading: false,
                updatePrePaidiQActivationMessage: false,
                updatePrePaidIQActivationError: action.error,
            };
        case actions.GET_PORTIN_ACTIVATION_FOR_REPUSH:
            return {
                ...state,
                portinsearchButtonLoading: true,
                portinActivatioList: [],
                portinActivatioListLoading: true,
                portinActivatioListError: null,
            };
        case actions.GET_PORTIN_ACTIVATION_FOR_REPUSH_SUCCESS:
            return {
                ...state,
                portinsearchButtonLoading: false,
                portinActivatioListLoading: false,
                portinActivatioList: action.result,
                portinActivatioListError: null,
            };
        case actions.GET_PORTIN_ACTIVATION_FOR_REPUSH_FAILED:
            return {
                ...state,
                portinsearchButtonLoading: false,
                portinActivatioListLoading: false,
                portinActivatioListError: action.error,
            };
        case actions.UPDATE_PORTIN_ACTIVATION_FOR_REPUSH:
            return {
                ...state,
                portinButtonLoading: true,
                updatePortinActivationError: null,
                updatePortinActivationMessage: null,
            };
        case actions.UPDATE_PORTIN_ACTIVATION_FOR_REPUSH_SUCCESS:
            return {
                ...state,
                portinButtonLoading: false,
                updatePortinActivationMessage: action.message,
                updatePortinActivationError: null,
            };
        case actions.UPDATE_PORTIN_ACTIVATION_FOR_REPUSH_FAILED:
            return {
                ...state,
                portinButtonLoading: false,
                updatePortinActivationMessage: false,
                updatePortinActivationError: action.error,
            };


        default:
            return state;
    }
}
